export const TRANSITIONS_WITH_EXTRACTED_DATA = {
    'Fade': {
        'transitionUrl': {
            'landscape': 'https://storage.googleapis.com/lumen5-prod-lottie/transitions/existing-transitions/Fade/landscape.json',
            'square': 'https://storage.googleapis.com/lumen5-prod-lottie/transitions/existing-transitions/Fade/square.json',
            'vertical': 'https://storage.googleapis.com/lumen5-prod-lottie/transitions/existing-transitions/Fade/vertical.json',
        },
        'transitionDuration': 200,
        'extractedData': {
            'transitionDuration': 199.99999999999997,
            'overlapDuration': 199.99999999999997,
            'inTransitionDuration': 199.99999999999997,
            'inTransitionStartTime': 0,
            'outTransitionDuration': 199.99999999999997,
            'outTransitionStartTime': 0,
        },
    },
    'FadeSlow': {
        'transitionUrl': {
            'landscape': 'https://storage.googleapis.com/lumen5-prod-lottie/transitions/existing-transitions/FadeSlow/landscape.json',
            'square': 'https://storage.googleapis.com/lumen5-prod-lottie/transitions/existing-transitions/FadeSlow/square.json',
            'vertical': 'https://storage.googleapis.com/lumen5-prod-lottie/transitions/existing-transitions/FadeSlow/vertical.json',
        },
        'transitionDuration': 600,
        'extractedData': {
            'transitionDuration': 600,
            'overlapDuration': 600,
            'inTransitionDuration': 600,
            'inTransitionStartTime': 0,
            'outTransitionDuration': 600,
            'outTransitionStartTime': 0,
        },
    },
    'Erase left': {
        'transitionUrl': {
            'landscape': 'https://storage.googleapis.com/lumen5-prod-lottie/transitions/existing-transitions/EraseLeft/landscape.json',
            'square': 'https://storage.googleapis.com/lumen5-prod-lottie/transitions/existing-transitions/EraseLeft/square.json',
            'vertical': 'https://storage.googleapis.com/lumen5-prod-lottie/transitions/existing-transitions/EraseLeft/vertical.json',
        },
        'transitionDuration': 200,
        'extractedData': {
            'transitionDuration': 199.99999999999997,
            'overlapDuration': 199.99999999999997,
            'inTransitionDuration': 199.99999999999997,
            'inTransitionStartTime': 0,
            'outTransitionDuration': 199.99999999999997,
            'outTransitionStartTime': 0,
        },
    },
    'Erase down': {
        'transitionUrl': {
            'landscape': null,
            'square': null,
            'vertical': null,
        },
        'transitionDuration': 0,
    },
    'Slide left': {
        'transitionUrl': {
            'landscape': 'https://storage.googleapis.com/lumen5-prod-lottie/transitions/existing-transitions/SlideLeft/landscape.json',
            'square': 'https://storage.googleapis.com/lumen5-prod-lottie/transitions/existing-transitions/SlideLeft/square.json',
            'vertical': 'https://storage.googleapis.com/lumen5-prod-lottie/transitions/existing-transitions/SlideLeft/vertical.json',
        },
        'transitionDuration': 200,
        'extractedData': {
            'transitionDuration': 199.99999999999997,
            'overlapDuration': 199.99999999999997,
            'inTransitionDuration': 199.99999999999997,
            'inTransitionStartTime': 0,
            'outTransitionDuration': 199.99999999999997,
            'outTransitionStartTime': 0,
        },
    },
    'Slide down': {
        'transitionUrl': {
            'landscape': 'https://storage.googleapis.com/lumen5-prod-lottie/transitions/existing-transitions/SlideDown/landscape.json',
            'square': 'https://storage.googleapis.com/lumen5-prod-lottie/transitions/existing-transitions/SlideDown/square.json',
            'vertical': 'https://storage.googleapis.com/lumen5-prod-lottie/transitions/existing-transitions/SlideDown/vertical.json',
        },
        'transitionDuration': 200,
        'extractedData': {
            'transitionDuration': 199.99999999999997,
            'overlapDuration': 199.99999999999997,
            'inTransitionDuration': 199.99999999999997,
            'inTransitionStartTime': 0,
            'outTransitionDuration': 199.99999999999997,
            'outTransitionStartTime': 0,
        },
    },
    'Circle': {
        'transitionUrl': {
            'landscape': null,
            'square': null,
            'vertical': null,
        },
        'transitionDuration': 0,
    },
    'CircleSlow': {
        'transitionUrl': {
            'landscape': 'https://storage.googleapis.com/lumen5-prod-lottie/transitions/existing-transitions/CircleSlow/landscape.json',
            'square': 'https://storage.googleapis.com/lumen5-prod-lottie/transitions/existing-transitions/CircleSlow/square.json',
            'vertical': 'https://storage.googleapis.com/lumen5-prod-lottie/transitions/existing-transitions/CircleSlow/vertical.json',
        },
        'transitionDuration': 1000,
        'extractedData': {
            'transitionDuration': 1000,
            'overlapDuration': 1000,
            'inTransitionDuration': 1000,
            'inTransitionStartTime': 0,
            'outTransitionDuration': 1000,
            'outTransitionStartTime': 0,
        },
    },
    'CircleRight': {
        'transitionUrl': {
            'landscape': 'https://storage.googleapis.com/lumen5-prod-lottie/transitions/existing-transitions/CircleRight/landscape.json',
            'square': 'https://storage.googleapis.com/lumen5-prod-lottie/transitions/existing-transitions/CircleRight/square.json',
            'vertical': 'https://storage.googleapis.com/lumen5-prod-lottie/transitions/existing-transitions/CircleRight/vertical.json',
        },
        'transitionDuration': 1000,
        'extractedData': {
            'transitionDuration': 1000,
            'overlapDuration': 1000,
            'inTransitionDuration': 1000,
            'inTransitionStartTime': 0,
            'outTransitionDuration': 1000,
            'outTransitionStartTime': 0,
        },
    },
    'CircleDown': {
        'transitionUrl': {
            'landscape': null,
            'square': null,
            'vertical': null,
        },
        'transitionDuration': 0,
    },
    'SkewedRight': {
        'transitionUrl': {
            'landscape': 'https://storage.googleapis.com/lumen5-prod-lottie/transitions/existing-transitions/SkewedRight/landscape.json',
            'square': 'https://storage.googleapis.com/lumen5-prod-lottie/transitions/existing-transitions/SkewedRight/square.json',
            'vertical': 'https://storage.googleapis.com/lumen5-prod-lottie/transitions/existing-transitions/SkewedRight/vertical.json',
        },
        'transitionDuration': 1000,
        'extractedData': {
            'transitionDuration': 1000,
            'overlapDuration': 1000,
            'inTransitionDuration': 1000,
            'inTransitionStartTime': 0,
            'outTransitionDuration': 1000,
            'outTransitionStartTime': 0,
        },
    },
    'SkewedDown': {
        'transitionUrl': {
            'landscape': null,
            'square': null,
            'vertical': null,
        },
        'transitionDuration': 0,
    },
    'ChevronRight': {
        'transitionUrl': {
            'landscape': 'https://storage.googleapis.com/lumen5-prod-lottie/transitions/existing-transitions/ChevronRight/landscape.json',
            'square': 'https://storage.googleapis.com/lumen5-prod-lottie/transitions/existing-transitions/ChevronRight/square.json',
            'vertical': 'https://storage.googleapis.com/lumen5-prod-lottie/transitions/existing-transitions/ChevronRight/vertical.json',
        },
        'transitionDuration': 1000,
        'extractedData': {
            'transitionDuration': 1000,
            'overlapDuration': 1000,
            'inTransitionDuration': 1000,
            'inTransitionStartTime': 0,
            'outTransitionDuration': 1000,
            'outTransitionStartTime': 0,
        },
    },
    'ChevronDown': {
        'transitionUrl': {
            'landscape': 'https://storage.googleapis.com/lumen5-prod-lottie/transitions/existing-transitions/ChevronDown/landscape.json',
            'square': 'https://storage.googleapis.com/lumen5-prod-lottie/transitions/existing-transitions/ChevronDown/square.json',
            'vertical': 'https://storage.googleapis.com/lumen5-prod-lottie/transitions/existing-transitions/ChevronDown/vertical.json',
        },
        'transitionDuration': 1000,
        'extractedData': {
            'transitionDuration': 1000,
            'overlapDuration': 1000,
            'inTransitionDuration': 1000,
            'inTransitionStartTime': 0,
            'outTransitionDuration': 1000,
            'outTransitionStartTime': 0,
        },
    },
    'RectangleOpenHorizontal': {
        'transitionUrl': {
            'landscape': 'https://storage.googleapis.com/lumen5-prod-lottie/transitions/existing-transitions/RectangleOpenHorizontal/landscape.json',
            'square': 'https://storage.googleapis.com/lumen5-prod-lottie/transitions/existing-transitions/RectangleOpenHorizontal/square.json',
            'vertical': 'https://storage.googleapis.com/lumen5-prod-lottie/transitions/existing-transitions/RectangleOpenHorizontal/vertical.json',
        },
        'transitionDuration': 1000,
        'extractedData': {
            'transitionDuration': 1000,
            'overlapDuration': 1000,
            'inTransitionDuration': 1000,
            'inTransitionStartTime': 0,
            'outTransitionDuration': 1000,
            'outTransitionStartTime': 0,
        },
    },
    'RectangleOpenVertical': {
        'transitionUrl': {
            'landscape': null,
            'square': null,
            'vertical': null,
        },
        'transitionDuration': 0,
    },
    'RectangleRight': {
        'transitionUrl': {
            'landscape': 'https://storage.googleapis.com/lumen5-prod-lottie/transitions/existing-transitions/RectangleRight/landscape.json',
            'square': 'https://storage.googleapis.com/lumen5-prod-lottie/transitions/existing-transitions/RectangleRight/square.json',
            'vertical': 'https://storage.googleapis.com/lumen5-prod-lottie/transitions/existing-transitions/RectangleRight/vertical.json',
        },
        'transitionDuration': 1000,
        'extractedData': {
            'transitionDuration': 1000,
            'overlapDuration': 1000,
            'inTransitionDuration': 1000,
            'inTransitionStartTime': 0,
            'outTransitionDuration': 1000,
            'outTransitionStartTime': 0,
        },
    },
    'RectangleDown': {
        'transitionUrl': {
            'landscape': 'https://storage.googleapis.com/lumen5-prod-lottie/transitions/existing-transitions/RectangleDown/landscape.json',
            'square': 'https://storage.googleapis.com/lumen5-prod-lottie/transitions/existing-transitions/RectangleDown/square.json',
            'vertical': 'https://storage.googleapis.com/lumen5-prod-lottie/transitions/existing-transitions/RectangleDown/vertical.json',
        },
        'transitionDuration': 1000,
        'extractedData': {
            'transitionDuration': 1000,
            'overlapDuration': 1000,
            'inTransitionDuration': 1000,
            'inTransitionStartTime': 0,
            'outTransitionDuration': 1000,
            'outTransitionStartTime': 0,
        },
    },
    'Diagonal slide': {
        'transitionUrl': {
            'landscape': null,
            'square': null,
            'vertical': null,
        },
        'transitionDuration': 0,
    },
    'GfK Diagonal slide': {
        'transitionUrl': {
            'landscape': 'https://storage.googleapis.com/lumen5-prod-lottie/transitions/existing-transitions/GfKDiagonalSlide/landscape.json',
            'square': 'https://storage.googleapis.com/lumen5-prod-lottie/transitions/existing-transitions/GfKDiagonalSlide/square.json',
            'vertical': 'https://storage.googleapis.com/lumen5-prod-lottie/transitions/existing-transitions/GfKDiagonalSlide/vertical.json',
        },
        'transitionDuration': 915,
        'extractedData': {
            'transitionDuration': 914.9999999999999,
            'overlapDuration': 914.9999999999999,
            'inTransitionDuration': 914.9999999999999,
            'inTransitionStartTime': 0,
            'outTransitionDuration': 914.9999999999999,
            'outTransitionStartTime': 0,
        },
    },
    'Diamond': {
        'transitionUrl': {
            'landscape': null,
            'square': null,
            'vertical': null,
        },
        'transitionDuration': 0,
    },
    'Square': {
        'transitionUrl': {
            'landscape': 'https://storage.googleapis.com/lumen5-prod-lottie/transitions/existing-transitions/Square/landscape.json',
            'square': 'https://storage.googleapis.com/lumen5-prod-lottie/transitions/existing-transitions/Square/square.json',
            'vertical': 'https://storage.googleapis.com/lumen5-prod-lottie/transitions/existing-transitions/Square/vertical.json',
        },
        'transitionDuration': 200,
        'extractedData': {
            'transitionDuration': 199.99999999999997,
            'overlapDuration': 199.99999999999997,
            'inTransitionDuration': 199.99999999999997,
            'inTransitionStartTime': 0,
            'outTransitionDuration': 199.99999999999997,
            'outTransitionStartTime': 0,
        },
    },
    'Transparent': {
        'transitionUrl': {
            'landscape': 'https://storage.googleapis.com/lumen5-prod-lottie/transitions/existing-transitions/Transparent/landscape.json',
            'square': 'https://storage.googleapis.com/lumen5-prod-lottie/transitions/existing-transitions/Transparent/square.json',
            'vertical': 'https://storage.googleapis.com/lumen5-prod-lottie/transitions/existing-transitions/Transparent/vertical.json',
        },
        'transitionDuration': 1000,
        'extractedData': {
            'transitionDuration': 1000,
            'overlapDuration': 1000,
            'inTransitionDuration': 1000,
            'inTransitionStartTime': 0,
            'outTransitionDuration': 1000,
            'outTransitionStartTime': 0,
        },
    },
    'None': {
        'transitionUrl': {
            'landscape': null,
            'square': null,
            'vertical': null,
        },
        'transitionDuration': 0,
    },
};
